import React, {Component} from 'react'
import {LAYOUT_TYPE_VERTICAL, LAYOUT_TYPE_HORIZONTAL} from './Scheduler'
import {SchedulerDay} from './SchedulerDay'
import {renderHourNamed} from './scheduler-utils'
import PropTypes from 'prop-types'
import styles from './Scheduler.css'
import SchedulerContext from './SchedulerContext'

class SchedulerContent extends Component {
  _context = {}

  renderContent = options => {
    this._context = options
    switch (options.layout) {
      case LAYOUT_TYPE_VERTICAL:
        return this._renderVerticalView()
      case LAYOUT_TYPE_HORIZONTAL:
        return this._renderHorizontalView()
      default:
        return <div />
    }
  }

  _renderHorizontalView = () => {
    const {viewDates} = this.props

    const rows = Object.values(viewDates).map((time, idx) => (
      <SchedulerDay key={idx} day={time} />
    ))

    const header = this._renderHorizontalHeader()
    return (
      <div style={{width: '100%', height: '100%'}}>
        {header}
        {rows}
        <div style={{height: 30}} />
      </div>
    )
  }

  _renderHorizontalHeader = () => {
    let header = [<div key={0} className={styles.headerContent} />]
    let {start, end, postBlock} = this._context.workDates
    let truncateLastHeader = false

    end = end - 1 - postBlock;
    // Check if the end time is on the half hour
    if (!Number.isInteger(end)) {
      end += 1
      truncateLastHeader = true
    }

    if (!Number.isInteger(start)) {
      end -= 1
    }

    for (let i = start; i <= end; i++) {
      const truncateHeader = i === Math.floor(end) && truncateLastHeader;
      header.push(renderHourNamed(i, false, i, truncateHeader))
    }
    return <div className={styles.view}>{header}</div>
  }

  _renderVerticalView = () => {
    const {viewDates, displayConflict} = this.props
    const isExpand = Object.keys(viewDates).length === 1
    const rows = Object.values(viewDates).map((time, idx) => {
      return (
        <SchedulerDay
          key={idx}
          day={time}
          displayConflict={displayConflict}
          isExpand={isExpand}
        />
      )
    })
    return (
      <div style={{width: '100%', height: '100%'}}>
        {rows}
        <div style={{height: 30}} />
      </div>
    )
  }

  render() {
    return (
      <SchedulerContext.Consumer>
        {values => this.renderContent(values)}
      </SchedulerContext.Consumer>
    )
  }
}

export default SchedulerContent

SchedulerContent.propTypes = {
  viewDates: PropTypes.object.isRequired
}
